export default "__VITE_ASSET__Ciw96$sS__"